import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function BrandStatement() {
  return (
    <section className="relative overflow-hidden bg-[#0f2a5c] text-white" data-testid="brand-statement">
      <div aria-hidden className="pointer-events-none absolute inset-0 opacity-30">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-sky-400 blur-3xl" />
      </div>
      <div className="relative mx-auto max-w-4xl px-5 sm:px-8 py-24 md:py-32 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-[11px] uppercase tracking-[0.3em] font-bold text-amber-300"
        >
          Morning Soft<sup className="text-[9px] ml-0.5">®</sup>
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="mt-5 font-display text-5xl sm:text-6xl md:text-7xl font-black tracking-tight leading-[1.02]"
        >
          Start your day<br /><em className="not-italic text-amber-400">in comfort.</em>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-8 text-lg md:text-xl text-sky-100/80 max-w-2xl mx-auto leading-relaxed"
        >
          Everyday essentials. Thoughtfully made for everyday life.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-10 flex flex-wrap items-center justify-center gap-3"
        >
          <Link
            to="/shop"
            data-testid="brand-statement-shop-btn"
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 text-[#0f2a5c] font-display font-bold px-8 py-4 text-sm uppercase tracking-widest hover:bg-white transition-colors"
          >
            Shop the Family <ArrowRight size={16} />
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 rounded-full border-2 border-white/40 text-white font-display font-bold px-8 py-4 text-sm uppercase tracking-widest hover:bg-white/10"
          >
            Our Story
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
